import { useDate } from 'Globals/useDate'
import { ChartFrame } from 'components/ChartFrame'
import ChartSelector from 'components/ChartSelector'
import { TimeStamp } from 'components/TimeStamp'
import { global_locales } from 'components/constants'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

const locales = global_locales.wastewaterrsv
const foot_locales = global_locales.wastewater

export const WasteWaterRSV = ({
  colorMode,
  lang,
}: {
  colorMode: 'dark' | 'light' | undefined
  lang: 'de' | 'fr'
}) => {
  const endDate = useDate()
  const [selected, setSelected] = useState(
    lang === 'fr' ? 'Genève' : 'Werdhölzli (ZH)'
  )


  return (
    <WasteWaterCovidRoot>
      <ChartFrame
        lang={lang}
        title={locales[lang].title}
        footnote={
          <>
            {foot_locales[lang].stations.all}{' '}
            {foot_locales[lang].stations[selected]}
          </>
        }
        timestamp={
          <>
            {new Date(endDate).toLocaleDateString(lang + '-CH', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
            })}
          </>
        }
        source={locales[lang].source}
        lead={locales[lang].lead}
        colorMode={colorMode}
      >
        <ChartSelector
          colorMode={colorMode}
          lang={lang}
          data={'rsv'}
          selected={selected}
          setSelected={setSelected}
        />
      </ChartFrame>
    </WasteWaterCovidRoot>
  )
}

const WasteWaterCovidRoot = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  /* background-color: red; */
`
